import { FC, ReactNode, useContext } from 'react';
import { Box, useTheme } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { Outlet, useMatch } from 'react-router-dom';
import { LegacyThemeContext } from 'src/theme/PosThemeScope';
import SubscriptionNoticeBar from 'src/components/SubscriptionNoticeBar';

import Sidebar from './Sidebar';
import Header from './Header';

interface SidebarLayoutProps {
  children?: ReactNode;
}

const SidebarLayoutFrame: FC<{ onPos: boolean }> = ({ onPos }) => {
  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          flex: 1,
          height: '100%',
          transition: 'background-color 0.3s ease',

          '.MuiPageTitle-wrapper': {
            // Modern: a painted title bar would cut the page gradient in half — keep it
            // transparent so the single canvas runs behind every page header.
            // Flat title band (the back-office new look; Modern keeps its own gradient canvas).
            background: 'transparent',
            marginBottom: `${theme.spacing(4)}`,
            [theme.breakpoints.down('sm')]: {
              marginBottom: `${theme.spacing(1.5)}`
            },
            [theme.breakpoints.between('sm', 'md')]: {
              marginBottom: `${theme.spacing(2)}`
            },
            transition: 'background 0.3s ease, box-shadow 0.3s ease',
            boxShadow: 'none'
          }
        }}
      >
        <Header />
        <Sidebar />
        <Box
          sx={{
            position: 'relative',
            zIndex: 5,
            display: 'block',
            flex: 1,
            pt: `${theme.header.height}`,
            transition: 'margin 0.3s ease',
            [theme.breakpoints.up('lg')]: {
              ml: `${theme.sidebar.width}`
            }
          }}
        >
          {/* Trial / subscription ending soon / expired — the same notice as the desktop till. */}
          {!onPos && <SubscriptionNoticeBar />}
          <Box display="block">
            <Outlet />
          </Box>
        </Box>
      </Box>
    </>
  );
};

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const current = useTheme();
  const legacy = useContext(LegacyThemeContext);
  // The touch POS keeps its original chrome too — cashier screens are not part of the new look.
  const onPos = Boolean(useMatch('/dashboard/terminal-3'));

  return (
    <ThemeProvider theme={onPos && legacy ? legacy : current}>
      <SidebarLayoutFrame onPos={onPos} />
    </ThemeProvider>
  );
};

export default SidebarLayout;
